import { Record, List, fromJS } from 'immutable';
import _ from 'lodash';

import { OpportunityAttendence, OpportunityType } from 'generated/graphql';

const properties = {
  id: '',
  locations: [],
  categories: [],
  providers: [],
  types: [],
  attendence: undefined,
};

export default class AutoSourcingRule extends Record(properties, 'AutoSourcingRule') {
  public readonly id!: string;

  public readonly locations!: List<string>;

  public readonly categories!: List<string>;

  public readonly providers!: List<string>;

  public readonly types!: List<OpportunityType>;

  public readonly attendence!: OpportunityAttendence;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      locations: fromJS(values.locations || []),
      categories: fromJS(values.categories || []),
      providers: fromJS(values.providers || []),
      types: fromJS(values.types || []),
    });
  }
}
